module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"invitationTip":"Available by invitation only","salary":"Salary"}}')
  delete Component.options._Ctor
}
